import { Outlet } from 'react-router-dom'

import { Skeleton } from '@reveni-io/reveni-ui'

import { performanceInsightsContentStatuses } from '../constants'
import PerformanceInsightsEmptyState from '../PerformanceInsightsEmptyState/PerformanceInsightsEmptyState'

const PerformanceInsightsContent = ({ status, periodParams }) => {
  if (status === performanceInsightsContentStatuses.loading) {
    return <Skeleton variant="rounded" width="100%" height={320} />
  }

  if (status === performanceInsightsContentStatuses.empty) {
    return <PerformanceInsightsEmptyState />
  }

  return <Outlet context={{ periodParams }} />
}

export default PerformanceInsightsContent
